import { Outlet } from "react-router";
import "./App.css";
import AppProvider from "providers/AppContext";
import UserProvider from "providers/UserContext";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <UserProvider>
          <Outlet />
        </UserProvider>
      </AppProvider>
    </div>
  );
}

export default App;
